// extracted by mini-css-extract-plugin
module.exports = {"card":"_2f3gndwEUsvbjaRvrB1SB5","grid":"_3FlUou5i5tA6uiZh2-F9YK","collapse":"b2xwenWXji9gL8K3YxzL0"};